import toggle from './directives/vtoggle';
import list from './directives/vlist';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

if (window) {
  window.requestAnimationFrame = window.requestAnimationFrame.bind(window); // fix IE11
}
gsap.registerPlugin(ScrollTrigger);

export default {
  install(Vue /*,  options */) {
    Vue.prototype.$fo = (() => {
      return {
        /**
         * 경로 토대로 언어 추출 반환 e.g) ko/company/~ -> ko
         * @param {String} value 체크할 경로, 없으면 window.location 참조
         * @returns {String | null} 추출한 언어 e.g) ko | en
         */
        getPathLocale: (value) => {
          let pathLocale = null;

          if (typeof window === 'undefined') {
            return pathLocale; // window 없으면 null 반환
          } else {
            pathLocale = value || window.location.pathname;
          }

          // ko|en
          const supportLocales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE;

          // /ko/company/~ -> ko
          pathLocale = pathLocale.replace(
            new RegExp('^\\/(' + supportLocales + ')|\\/|(.+)', 'g'),
            '$1'
          );

          // 매칭 안되면 null
          if (pathLocale === '') {
            pathLocale = null;
          }

          return pathLocale;
        },
        /**
         * 한자리 숫자 앞에 0 붙이는 함수
         * @param {Number} value
         * @returns {String}
         */
        force2Digits: (value) => {
          return value < 10 ? '0' + String(value) : String(value);
        },
        /**
         * invalied 에 커서 넣기
         * @param {Element} elm valied 검사할 부모 element
         */
        focusInvalid: (elm) => {
          const errorElm = elm.querySelectorAll('.failed').item(0);
          const target = 'input, textarea, select';
          const tagName = errorElm.tagName.toLowerCase();

          if (target.split(', ').indexOf(tagName) >= 0) {
            // errorElm가 form 요소 자체인 경우
            errorElm.focus();
            if (tagName === 'input' || tagName === 'textarea') {
              errorElm.select();
            }
          } else {
            if (errorElm && errorElm.querySelectorAll(target).length) {
              const input = errorElm.querySelectorAll(target).item(0);
              input.focus();
              if (tagName === 'input' || tagName === 'textarea') {
                input.select();
              }
            }
          }
        }
      };
    })();

    Vue.prototype.$system = (() => {
      return {
        download: (path) => {
          var a = document.createElement('A');
          a.href = path;
          a.download = path.substr(path.lastIndexOf('/') + 1);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      };
    })();

    Vue.directive('toggle', toggle);
    Vue.directive('list', list);
  }
};
